import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Terms.css';

// Импортируем изображения (PNG или JPG)
import taxiIcon from '../assets/icons/taxi.png'; // Пример: значок taxi
import carwashIcon from '../assets/icons/carwash.png'; // Пример: значок мойка
import userIcon from '../assets/icons/user.png'; // Пример: значок пользователя
import moneyIcon from '../assets/icons/money.png'; // Пример: значок денег
import documentIcon from '../assets/icons/document.png'; // Пример: значок документа
import clockIcon from '../assets/icons/clock.png'; // Пример: значок часов
import businnessIcon from '../assets/icons/businness.png'; // Пример: значок бизнес
import cityIcon from '../assets/icons/city.png'; // Пример: значок города
import planeIcon from '../assets/icons/plane.png'; // Пример: значок самолета
import locationIcon from '../assets/icons/location.png'; // Пример: значок метки
import ClockRef from '../assets/icons/clock-ref.png'; // Пример: значок метки

const Terms = () => {
  const faq = [
    { question: 'Как забронировать автомобиль?', answer: 'Выберите автомобиль из каталога и заполните форму бронирования.' },
    { question: 'Как оплатить аренду?', answer: 'Оплата производится наличными или через терминал при получении автомобиля.' },
    { question: 'Можно ли отменить бронирование?', answer: 'Да, но только до начала аренды.' },
  ];

  const rentalRules = [
    { text: 'ПОД ТАКСИ НЕ СДАЁМ', icon: taxiIcon }, // Изображение автомобиля
    { text: 'Возраст: от 25 лет, стаж вождения от 5 лет', icon: userIcon }, // Изображение пользователя
    { text: 'Документы: паспорт и водительское удостоверение (РФ)', icon: documentIcon }, // Изображение документа
    { text: 'Без залога', icon: moneyIcon }, // Изображение денег
    { text: 'Мойка автомобиля: от 700 руб.', icon: carwashIcon }, // Изображение автомобиля
    { text: 'Оформление: занимает 10-15 минут', icon: clockIcon }, // Изображение часов
    { text: 'Работаем: с физ. и юр. лицами', icon: businnessIcon }, // Изображение здания
    { text: 'Расчетное время: 11:00. За каждый последующий час +300 руб', icon: ClockRef }, // Изображение возврат
  ];

  const deliveryCosts = [
    { text: 'По городу: 700 руб', icon: cityIcon }, // Изображение грузовика
    { text: 'Аэропорт Храброво: 1200 руб', icon: planeIcon }, // Изображение самолета
    { text: 'г. Зеленоградск: 2000 руб', icon: locationIcon }, // Изображение метки
    { text: 'г. Светлогорск: 2500 руб', icon: locationIcon },
    { text: 'пгт. Янтарный: 3000 руб', icon: locationIcon },
  ];

  return (
    <div className="terms-page">
      <Helmet>
        <title>Условия аренды автомобилей - ReserveCar</title>
        <meta name="description" content="Условия аренды автомобилей в нашей компании." />
      </Helmet>
      <div className="terms-container">
        <h1 className="title">Условия аренды</h1>
        <p className="intro">Ознакомьтесь с основными правилами аренды автомобилей в нашей компании.</p>

        {/* Плитки для "Правила аренды" */}
        <div className="terms-section">
          <h2>Правила аренды</h2>
          <div className="tiles-container">
            {rentalRules.map((item, index) => (
              <div key={index} className="tile">
                <img src={item.icon} alt={`${item.text} icon`} className="icon" />
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Плитки для "Стоимость доставки автомобилей" */}
        <div className="terms-section">
          <h2>Стоимость доставки автомобилей</h2>
          <div className="tiles-container">
            {deliveryCosts.map((item, index) => (
                <div key={index} className="tile">
                  <img src={item.icon} alt={`${item.text} icon`} className="icon"/>
                  <p className="text">{item.text.split(':')[0]}</p> {/* Место доставки */}
                  <p className="price">{item.text.split(':')[1]}</p> {/* Цена */}
                </div>
            ))}
          </div>
        </div>

        <div className="faq-section">
          <h2 className="faq-title">Часто задаваемые вопросы:</h2>
          <div className="faq">
            {faq.map((item, index) => (
              <div key={index} className="faq-item">
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;